import React from 'react';
import { CTitle } from '../../components/Widget';
import arrow from '../../../../../../assets/2025/arrow.gif';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
interface ISection1Props {
  settings: any;
}

const Section1: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '2';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = React.useMemo(
    () => settings?.paragraphs[1],
    [settings?.paragraphs]
  );
  const updateComponentState = useUpdateComponentState();
  const [state, setState] = React.useState({
    play: 1,
    isPlayed: false,
    factorPlay: 1,
    isFactorPlayed: false,
  });

  // 协作
  const [isCollaboration, setIsCollaboration] = React.useState(false);
  // 沟通
  const [isCommunication, setCommunication] = React.useState(false);

  const collaboration = (next = 1) => {
    if (state.isPlayed) {
      return;
    }
    updateComponentState(p_course, p_topic, ID, 'education-iws-section1-2');
    setIsCollaboration(true);
    next += 1;
    setState({ ...state, play: next, isPlayed: true });
    if (next <= 4) {
      setTimeout(() => collaboration(next), 1000);
    }
  };

  const startCommunication = (next = 1) => {
    if (state.isFactorPlayed) {
      return;
    }
    updateComponentState(p_course, p_topic, ID, 'education-iws-section1-1');
    setCommunication(true);
    next += 1;
    setState({ ...state, factorPlay: next, isFactorPlayed: true });
    if (next <= 4) {
      setTimeout(() => startCommunication(next), 1000);
    }
  };

  return (
    <div className="topic-section-1 topic-section-1-en">
      <div>
        <div className="tool-title">
          <CTitle title={paragraphsSettings.title} />
        </div>
        <div className="tool-content" id="education-iws-section1-1">
          <div
            className="tool-tips"
            dangerouslySetInnerHTML={{
              __html: paragraphsSettings?.l1,
            }}
          ></div>
          {!isCommunication && <img className="arrow" src={arrow} alt="" />}
          <div className="tool-practice tool-orange">
            <span></span> <div>{paragraphsSettings.l1LeftListDesc}</div>
          </div>
          {paragraphsSettings.l1LeftList?.map((item: string, i: number) => (
            <div
              key={i}
              className={`tool-item tool-item-${i + 1}  ${
                state.factorPlay > i ? 'box-fade-right-in' : ''
              }`}
              onClick={i === 0 ? () => startCommunication() : undefined} // 点击第一个项目触发动画
            >
              <span>{item}</span>
            </div>
          ))}
        </div>

        <div
          className="tool-content tool-content2"
          id="education-iws-section1-2"
        >
          {!isCollaboration && <img className="arrow2" src={arrow} alt="" />}
          <div className="tool-practice  tool-purple">
            <span></span> <div>{paragraphsSettings.l1RightListDesc}</div>
          </div>
          {paragraphsSettings.l1RightList?.map((item: string, i: number) => (
            <div
              key={i}
              className={`tool-item tool-item-${i + 1} ${
                state.play > i ? 'box-fade-in' : ''
              }`}
              onClick={i === 0 ? () => collaboration() : undefined} // 点击第一个项目触发动画
            >
              <span>{item}</span>
            </div>
          ))}
          <div
            className="tool-tips"
            dangerouslySetInnerHTML={{
              __html: paragraphsSettings?.l1Right,
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default Section1;
